import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import useGetPollingInterval from "../../../hooks/useGetPollingInterval";
import { Activite } from "../../../models/Activite";
import { Magasin } from "../../../models/Magasin";
import { Planogramme } from "../../../models/Planogramme";
import {
  planoAPI,
  useGetActivitesQuery,
  useGetPlanoQuery
} from "../../../redux/features/cache";
import { useAppDispatch, useAppSelector } from "../../../redux/store";
import FormEditMagasinProduit from "./FormEditMagasinProduit";
import { FormEditProduit } from "./Forms/FormEditProduit";
import { ModificationLotMagasins } from "./ModificationLotMagasins";

interface IWrapperEditMagasin {
  prod: any;
  setUnsaved: Dispatch<SetStateAction<boolean>>;
  setOpenNewProduit: any;
  setListMags: any;
  setAddProductTitle: any;
  setOpenModalEdit: any;
  setSelectedRow: any;
  magasins: Magasin[];
}

export const WrapperEditMagasin = (props: IWrapperEditMagasin) => {
  const {
    prod,
    setUnsaved,
    setOpenNewProduit,
    setListMags,
    setAddProductTitle,
    setOpenModalEdit,
    setSelectedRow,
    magasins,
  } = props;

  const pollingInterval = useGetPollingInterval();
  const showUCCOnly = useAppSelector((state) => state.appState.showUCCOnly);
  const {
    isFetching: isFetchingPlano,
    data: plano = [] as Planogramme[]
  } = useGetPlanoQuery(
    { prod: prod, statut: "", ban: "", mag: "", manquant: false, ucc: showUCCOnly },
    { pollingInterval: pollingInterval }
  );

  const { data: activites = [] as Activite[] } = useGetActivitesQuery(false);

  const [listChecked, setListchecked] = useState<Planogramme[]>(
    [] as Planogramme[]
  );

  const [planogrammes, setPlanogrammes] = useState<Planogramme[]>([]);

  useEffect(() => {
    if (!isFetchingPlano) {
      // Élimine le magasin web des planogrammes, 
      // le web ne faisant pas partie des `magasins`.
      const editablePlanogrammes = plano.filter(plano =>
        magasins.some(magasin =>
          magasin.mag_num === plano.mag_num
        )
      );

      setPlanogrammes(editablePlanogrammes);
    }
  }, [isFetchingPlano, magasins, plano]);

  const prod_plano = useAppSelector((state) => state.appState.prod_plano);
  const dispatch = useAppDispatch();

  useEffect(() => {
    let listMagasins = planogrammes.map((planogramme) => planogramme.magasin);
    let checkedMagasins = planogrammes.filter((planogramme) => planogramme.isChecked === true);
    setListchecked(checkedMagasins);
    setListMags(listMagasins);
  }, [planogrammes, setListMags]);

  const handleChange = (index: number) => {
    dispatch(
      planoAPI.util.updateQueryData(
        "getPlano",
        { prod: prod, statut: "", ban: "", mag: "", manquant: false, ucc: showUCCOnly },
        (planogramme) => {
          planogramme[index].isChecked = !planogramme[index].isChecked;
          return planogramme;
        }
      )
    );
  };

  const handleAll = (e: any) => {
    dispatch(
      planoAPI.util.updateQueryData(
        "getPlano",
        { prod: prod, statut: "", ban: "", mag: "", manquant: false, ucc: showUCCOnly },
        (planogramme) => {
          planogramme.forEach((x) => {
            if (!e.target.checked) {
              x.isChecked = false;
            } else {
              x.isChecked = true;
            }
          });
          return planogramme;
        }
      )
    );
  };

  return (
    <>
      {planogrammes.length > 0 && (
        <Box>
          <FormEditProduit
            produit={planogrammes[0].produit}
            section={planogrammes[0].section}
            allCode={activites}
            setUnsaved={setUnsaved}
          />
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
            <Typography
              variant="h4"
              sx={{ fontWeight: "bold", ml: 2, color: "#007bff" }}
            >
              Magasins
            </Typography>
            <Button
              id="add-store-button"
              variant="contained"
              sx={{ backgroundColor: "#007bff", borderRadius: "30px", m: 1 }}
              onClick={() => {
                setOpenNewProduit(true);
                setAddProductTitle("Ajouter un magasin");
              }}
              disabled={!prod_plano.canAdd}
            >
              Ajouter un magasin
            </Button>
          </Box>
          <Divider
            variant="middle"
            sx={{ backgroundColor: "#007bff", mb: 4 }}
          />
        </Box>
      )}
      {listChecked.length > 0 && (
        <>
          <ModificationLotMagasins
            storePlanograms={listChecked}
            setOpenModalEdit={setOpenModalEdit}
            setSelectedRow={setSelectedRow}
            setListMags={setListMags}
            productNumber={prod}
          />
          <Divider
            variant="middle"
            sx={{ backgroundColor: "#007bff", mb: 4 }}
          />
        </>
      )}
      <FormControlLabel
        control={<Checkbox checked={listChecked.length > 0} />}
        label="Tous les magasins"
        onClick={(e) => handleAll(e)}
      />
      {planogrammes.map((planogramme, index) => (

        <Box
          sx={{ display: "flex", borderBottom: "1px black solid", m: 1, alignItems: "center" }}
          key={index}
        >
          <Checkbox
            checked={planogramme.isChecked}
            onChange={(e) => {
              handleChange(index);
            }}
            key={Math.random()}
          />
          <FormEditMagasinProduit
            data={planogramme}
            index={index}
            key={`${planogramme.plano_seq}`}
            setUnsaved={setUnsaved}
            listChecked={listChecked}
          />
        </Box>
      ))}
    </>
  );
}
